import * as cart from '@shopify/theme-cart';
import * as cartHandler from './components/cartHandling';
import * as imageSlider from './components/imageSlider';
import * as cookieHandler from "./components/cookies";
import { initInfiniteScroll } from './components/infiniteScroll';
import { initSearchOverlay } from './components/searchOverlay';

window.cart = cart;
window.cartHandler = cartHandler;
window.imageSlider = imageSlider;

initInfiniteScroll();
initSearchOverlay();

if (!cookieHandler.getCookie('newsletterPopup')){
    setTimeout(function () {
        Fancybox.show([
            {
                src: "#newsletter-popup",
                type: "inline",
            }
        ]);
    }, 6000);

    cookieHandler.setCookie('newsletterPopup', 'true', 20);
}

